import { TLocationDropdownOption } from '@src/features/shift-post-v2/steps/shift-details-step/components/location-section/location-section.types'
import { debounce } from '@src/helpers/helperFuncs'
import { IProperty, PROPERTY_STATUS } from '@src/models/Property'
import { API } from '@src/network'

/**
 * Maps an array of properties to an array of property options for dropdown
 * @param data An array of properties
 * @returns An array of property options for dropdown
 */
const propertiesOptionsMapper = async (
  data: IProperty[],
): Promise<TLocationDropdownOption[]> => {
  const options = data.map(value => ({
    value: value.id,
    label: value.name,
    name: value.name,
    min_wage: value.min_wage,
    action: value.id,
    timezone: value.timezone,
    commission_percent: value.commission_percent,
    suggested_pay_rate: value.suggested_pay_rate,
    property_arrival_instructions: value.arrival_instructions_rich_text,
    status: value.status,
    isDisabled: value.status === PROPERTY_STATUS.PENDING,
    active_overtime_policy: value.active_overtime_policy,
  }))
  return options
}

/**
 * Asynchronously load options when user searches in the select input
 */
const loadLocationOptions = async (inputValue: string, callback: any) => {
  const response = await API.Properties.getProperties({
    search: inputValue,
    paginate: false,
    include: ['active_overtime_policy'],
  })
  const options = await propertiesOptionsMapper(response.data)
  callback(options)
}

export const debouncedLoadLocationOptions = debounce(loadLocationOptions, 300)

export const MOCK_ARRIVAL_INSTRUCTIONS =
  'We are looking for friendly and reliable banquet servers to assist at an upcoming event. The job includes serving food and beverages, keeping tables clean, and providing excellent customer service. No prior experience is required, but a professional attitude and the ability to work in fast paced environment is a must.'

export const MOCK_LOCATION_NAME = 'Millstone Road'
